const USER_INFO_KEY = 'userInfo';
const SELECTED_SPORT_KEY = 'selectedSport';
export const SELECTED_SPORT_CHANGE_EVENT = 'selected-sport-change';
export const AUTH_STATE_CHANGE_EVENT = 'auth-state-change';

function dispatchBrowserEvent(eventName: string, detail?: unknown) {
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(eventName, { detail }));
    }
}

class LocalStorageService {
    public addUserInfo<T>(userData: T) {
        localStorage.setItem(USER_INFO_KEY, JSON.stringify(userData));
        dispatchBrowserEvent(AUTH_STATE_CHANGE_EVENT, userData);
    }

    public getUserInfo<T>() {
        const rawValue = localStorage.getItem(USER_INFO_KEY);

        if (!rawValue) {
            return null as T | null;
        }

        try {
            return JSON.parse(rawValue) as T;
        } catch {
            localStorage.removeItem(USER_INFO_KEY);
            return null as T | null;
        }
    }

    public setSelectedSport(sportCode: string) {
        localStorage.setItem(SELECTED_SPORT_KEY, sportCode);
        dispatchBrowserEvent(SELECTED_SPORT_CHANGE_EVENT, sportCode);
    }

    public getSelectedSport() {
        return localStorage.getItem(SELECTED_SPORT_KEY);
    }

    public clearAll() {
        const hadStoredAuthState =
            localStorage.getItem(USER_INFO_KEY) !== null ||
            localStorage.getItem(SELECTED_SPORT_KEY) !== null;

        localStorage.removeItem(USER_INFO_KEY);
        localStorage.removeItem(SELECTED_SPORT_KEY);

        if (hadStoredAuthState) {
            dispatchBrowserEvent(AUTH_STATE_CHANGE_EVENT, null);
        }
    }
}

const localStorageService = new LocalStorageService();

export default localStorageService;
